"use strict";
import { getOverlayPosition, useLayoutEffect } from "../utils";
import { useState } from "react";
import { useCallback } from "react";
import observeRect from "@reach/observe-rect";
const useOverlayPosition = (getOverlayPositionProps = {}) => {
  const [targetElement, setTargetElement] = useState(null);
  const [overlayElement, setOverlayElement] = useState(null);
  const targetRef = useCallback((node) => setTargetElement(node), []);
  const overlayRef = useCallback((node) => setOverlayElement(node), []);
  const [targetRect, setTargetRect] = useState();
  const [overlayRect, setOverlayRect] = useState();
  useLayoutEffect(() => {
    if (!targetElement || !overlayElement) {
      return;
    }
    const targetRectObserver = observeRect(targetElement, setTargetRect);
    const overlayRectObserver = observeRect(overlayElement, setOverlayRect);
    targetRectObserver.observe();
    overlayRectObserver.observe();
    return () => {
      targetRectObserver.unobserve();
      overlayRectObserver.unobserve();
    };
  }, [targetElement, overlayElement]);
  const overlayProps = getOverlayPosition({
    targetRect,
    overlayRect,
    ...getOverlayPositionProps
  });
  return {
    overlayProps: {
      ...overlayProps,
      width: targetRect ? targetRect.width : 0
    },
    overlayRef,
    targetRef,
    targetElement
  };
};
export default useOverlayPosition;
